<div id="auth-modal">
    <div class="modal-header">
        <h2 class="title">{{ title }}</h2>
        <button
            *ngIf="activeModal"
            type="button"
            class="close"
            aria-label="Close"
            (click)="closeAuthModal()"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="tabs-wrapper">
            <a [ngClass]="{ active: !isStudentTab }" (click)="activateTeacherTab()"> Teacher </a>
            <a
                *ngIf="activeModal"
                class="selenium-modal-student-link"
                [ngClass]="{ active: isStudentTab }"
                (click)="activateStudentTab()"
            >
                Student
            </a>
            <a *ngIf="!activeModal" [href]="getStudentUrl()" class="selenium-modal-student-link">
                Student <em class="fas fa-external-link-alt"></em>
            </a>
        </div>
        <div class="description-wrapper">
            <p>
                {{ description }}
            </p>
        </div>
        <!-- Region: Teacher Auth Buttons -->
        <div *ngIf="!isStudentTab" class="auth-links-wrapper">
            <a [href]="userService.getGoogleAuthUrl(nextURL)" class="auth google">
                <img class="auth-icon" [src]="googleImage" alt="Google Auth" />
                Google
            </a>
            <a [href]="userService.getFacebookAuthUrl(nextURL)" class="auth facebook">
                <img class="auth-icon" [src]="facebookImage" alt="Facebook Auth" />
                Facebook
            </a>
            <a [href]="userService.getPbsAuthUrl(nextURL, pbsEmailRegister)" class="auth pbs">
                <em class="auth-icon fas fa-envelope"></em>
                Email
            </a>
        </div>
        <!-- /Region: Teacher Auth Buttons -->
        <div *ngIf="activeModal && isStudentTab" class="student-auth-wrapper">
            <!-- Region: Student Auth Step One -->
            <div
                *ngIf="studentLogin.shouldDisplayUsernameInput()"
                class="student-auth-step-one-wrapper"
            >
                <div class="student-sign-in-text">
                    Sign in using your PBS LearningMedia username:
                </div>
                <div class="username-input">
                    <app-input-box
                        label="Username"
                        [(inputModel)]="studentUsername"
                        (click)="
                            studentLogin.isLoginInitiated = false;
                            studentLogin.restoreInitialSecretQuestionValue()
                        "
                        (keydown.enter)="studentLogin.initiateLogin(studentUsername)"
                    >
                    </app-input-box>
                    <app-button (click)="studentLogin.initiateLogin(studentUsername)">
                        Next
                    </app-button>
                </div>
                <app-error-message
                    *ngIf="
                        studentLogin.getSecretQuestion() == null && studentLogin.isLoginInitiated
                    "
                    errorMessage="This username does not exist."
                >
                </app-error-message>
            </div>
            <!-- /Region: Student Auth Step One -->
            <!-- Region: Student Auth Step Two -->
            <div
                *ngIf="studentLogin.shouldDisplayQuestionInput()"
                class="student-auth-step-two-wrapper"
            >
                <div class="student-sign-in-text">
                    Answer your secret question to finish signing in. <br />
                    {{ studentLogin.getSecretQuestion() }}
                </div>
                <div class="secret-answer-input">
                    <app-input-box
                        label="{{ studentLogin.generateLabelFromSecretQuestion() }}"
                        [(inputModel)]="secretAnswer"
                        (click)="
                            studentLogin.isLoginValidationInitiated = false;
                            studentLogin.restoreInitialLoginEvaluationValue()
                        "
                        (keydown.enter)="studentLogin.validateLogin(secretAnswer)"
                    >
                    </app-input-box>
                    <app-button (click)="studentLogin.validateLogin(secretAnswer)"> Go</app-button>
                </div>
                <app-error-message
                    *ngIf="
                        studentLogin.getLoginValidity() === 'False' &&
                        studentLogin.isLoginValidationInitiated
                    "
                    errorMessage="This answer does not match your original one. Please try again."
                >
                </app-error-message>
            </div>
            <!-- /Region: Student Auth Step Two -->
            <hr />
            <div class="google-auth-wrapper">
                <a
                    [href]="userService.getGoogleAuthUrl(getStudentNext(), true)"
                    class="auth google selenium-continue-google"
                >
                    <img class="auth-icon" [src]="googleImage" alt="Google Auth" />
                    Continue with Google
                </a>
            </div>
        </div>
        <div *ngIf="activeModal" class="register-caption-wrapper">
            <span>{{ registerDescription }}</span>
            <span *ngIf="!isStudentTab">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="/signup/"
                    (click)="closeAuthModal()"
                    class="selenium-modal-signup-link"
                >
                    {{ registerLinkText }}
                    <em class="fas fa-external-link-alt"></em>
                </a>
            </span>
            <span *ngIf="isStudentTab">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="/student/signup/"
                    (click)="closeAuthModal()"
                    class="selenium-modal-signup-link"
                >
                    {{ registerLinkText }}
                    <em class="fas fa-external-link-alt"></em>
                </a>
            </span>
        </div>
        <div *ngIf="!activeModal" class="register-caption-wrapper">
            <span>{{ registerDescription }}</span>
            <span
                ><a (click)="isStudent ? openStudentAuthModal() : openAuthModal()">{{
                    registerLinkText
                }}</a></span
            >
        </div>
    </div>
</div>
